import React, { useEffect, useContext } from "react";
import { Navigate } from "react-router-dom";
import { API } from "../../api/API";
import { LOGOUT_URL } from "../../config/config";
import { SecurityContext } from "../../security/SecurityContext";
import { PaymentCartContext } from 'pages/payment-cart/PaymentCartContext';

const LogoutPage = props => {
  const {
    authState,
    handleLogout
  } = useContext(SecurityContext);
  const { emptyCart } = useContext(PaymentCartContext);

  useEffect(() => {
    API.post(LOGOUT_URL)
    .then(resposnse => {
      handleLogout();
      emptyCart();
    })
    .catch(err=>{
      console.log("Error in logging out",err);
      handleLogout();
    });
    
  }, [authState]);

  return (
    <>
      <Navigate to="/login" replace />
    </>
  );
};

export default LogoutPage;
